import { useAppDispatch } from '../../../../redux/hooks'
import React, { useCallback, useMemo } from 'react'
import { useTranslation } from '../../../../hooks/locale'
import { useSelector } from 'react-redux'
import {
    getCurrentOpenedFilterModal,
    getFiltersConfiguration,
    revertFiltersConfiguration,
    pushModal,
    popModal,
} from '../../../../redux/filters'
import { FilterModalType } from '../../filter-sort-section/types'
import { FilterSectionTransport } from '../../../../transports/search-result-listing-static-transport'
import FilterModal from '../filter-modal'
import { ChipWrapper, Container, FilterBadge, FilterIcon } from './styles'
import { Chip } from 'react-components'

interface Props {
    filterStaticData: FilterSectionTransport
    showOnlyIcon?: boolean
}

const FilterPill: React.FC<Props> = ({ filterStaticData, showOnlyIcon = false }) => {
    const dispatch = useAppDispatch()
    const { t } = useTranslation()
    const currentOpenedFilterModal = useSelector(getCurrentOpenedFilterModal)
    const filtersConfiguration = useSelector(getFiltersConfiguration)

    const activeFiltersCount = useMemo(() => {
        return (
            filtersConfiguration?.filters?.reduce((acc, filter) => {
                return acc + (filter.items?.filter(item => item.checked).length || 0)
            }, 0) || 0
        )
    }, [filtersConfiguration])

    const hasActiveFilters = activeFiltersCount > 0

    const handleModalToggle = useCallback(() => {
        if (currentOpenedFilterModal === FilterModalType.FILTERS) {
            dispatch(revertFiltersConfiguration())
            dispatch(popModal())
        } else {
            dispatch(pushModal(FilterModalType.FILTERS))
        }
    }, [currentOpenedFilterModal, dispatch])

    const handleMainFilterClick = useCallback(() => {
        handleModalToggle()
    }, [handleModalToggle])

    const label = showOnlyIcon ? '' : t('mobileFilter.filters')

    return (
        <Container>
            <ChipWrapper>
                <Chip
                    onClick={handleMainFilterClick}
                    label={label}
                    icon={<FilterIcon />}
                    size="small"
                    selected={hasActiveFilters}
                />
                {hasActiveFilters && <FilterBadge>{activeFiltersCount}</FilterBadge>}
            </ChipWrapper>
            <FilterModal handleModalToggle={handleModalToggle} filterStaticData={filterStaticData} />
        </Container>
    )
}

export default FilterPill
